module.exports = __webpack_public_path__ + "img/SettingsIcon.eeec9d8b.svg";